import { Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import { ReportsDataModel } from 'src/app/reports/reports-data-model';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { AppComponentBase } from '../app-component-base';

@Component({
	selector: 'app-date-range-form',
	templateUrl: './date-range-form.component.html',
	styleUrls: ['./date-range-form.component.scss']
})
export class DateRangeFormComponent extends AppComponentBase implements OnInit {

	@Output() onEmitDateRange: EventEmitter<any> = new EventEmitter<any>();
	reportsDataModel = new ReportsDataModel();
	todayDate = new Date();
	dateRange = this.reportsDataModel.reportsDateRangeModel;
	dateFormat = 'YYYY-MM-DD';

	constructor(
		injector: Injector,
		private toastr: ToastrService,
	) { 
		super(injector);
		this.dateRange.start = moment(this.todayDate).subtract(2, 'months').format();
		this.dateRange.end = this.todayDate;
	}

	ngOnInit() {
		this.onSetOrChangeRange();
	}

	onSetOrChangeRange() {
		this.onEmitDateRange.emit(this.dateRange);	
	}

	onChangeDate(event: any, type: string, value: any) {
		setTimeout(() => {
			value = moment(event.value).format();
			const start = moment(this.dateRange.start).format();
			const end = moment(this.dateRange.end).format();
			if (type === 'start' && start > end) {
				this.toastr.error(`From date can't be greater then to.`);
				this.dateRange.start = moment(end).subtract(1, 'months').format();
				return;
			} else if (type === 'end' && end < start) {
				this.toastr.error(`To date can't be less then from.`);
				this.dateRange.end = moment(start).add(1, 'months').format();
				return;
			}
		});
	}

}


